export default __webpack_public_path__ + "static/media/IMPUESTOSESTATALES2024.d16197ca.pdf";